import { produce } from "immer";
import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { e_library_type, ELibraryApi, file_response_e_library, library_details } from "../../../../api/e-library/e_library.api";
import { library_type_list, LibraryTypeApi } from "../../../../api/library-type/library_type.api";
import { library_author_list, LibraryAuthorApi } from "../../../../api/library-author/library_author.api";
import { document_category_type, ELibraryCategory, FILE_TYPE_DATA, LIBRARY_DETAIL_TYPE, LIBRARY_FILE_TYPE, media_type_data, STATUS_E_LIBRARY } from "../../enum/elibrary_enum";
import { routeName } from "../../../../routes/routeName";
import { useDispatch } from "react-redux";
import { setLoading, unsetLoading } from "../../../../store/loading/loading.slice";
import { alertError, alertSuccess } from "../../../../components/alert/swal";


enum NUM_TYPE_MODAL {
    CLOSE = "",
    FOR_SALE = "FOR_SALE",
    FOR_LEND = "FOR_LEND"
}
type mode_status = 'DRAFT' | "SUBMIT"

export const useManageState = ({ library_category_name }: { library_category_name: string }) => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const location = useLocation();
    const pathname = location.pathname;
    const navigate = useNavigate();

    const [cover_file, set_cover_file] = useState<any>(null);
    const [example_book, set_example_book] = useState<any>(null);
    const [complete_book, set_complete_book] = useState<any>(null);
    const [video_file, set_video_file] = useState<any>(null);
    const [video_link, set_video_link] = useState<string>("");

    const [podcast_file, set_podcast_file] = useState<any[]>([]);

    const default_state: e_library_type = {
        is_draft: false,
        id_library_author_publisher: null,
        id_library_category: null,
        language: "",
        library_author_publisher: "",
        library_category_desc: "",
        library_category_name: "",
        library_details: [],
        library_episodes: null,
        library_files: [],
        library_head_name: "",
        library_head_status: "",
        library_page: null,
        library_payment_day: null,
        library_payment_hour: null,
        library_rent_day: null,
        library_rent_hour: null,
        id_library_author_by: null,
        library_author_by: "",
        library_head_types: []
    }

    const [formState, setFormState] = useState<e_library_type>(default_state);

    type category_list = {
        library_category_name: string;
        id_library_category: number | null
    }
    const [id_category, set_id_category] = useState<category_list>({ id_library_category: null, library_category_name: "" })
    const [document_category_type, set_document_category_type] = useState<document_category_type[]>([])
    const [library_type, set_library_type] = useState<any[]>([]);
    const [id_library_type, set_id_library_type] = useState<any[]>([]);
    const [search_library_type, set_search_library_type] = useState<string>("");
    const [library_author, set_library_author] = useState<any[]>([]);
    const [id_library_author, set_id_library_author] = useState<any>(null);
    const [search_library_author, set_search_library_author] = useState<string>("");
    const [publisher, set_publisher] = useState<any[]>([]);
    const [id_publisher, set_id_publisher] = useState<any>(null);
    const [search_publisher, set_search_publisher] = useState<string>("");
    const [status, set_status] = useState<string>(STATUS_E_LIBRARY.DRAFT);

    const [qty_for_sale, set_qty_for_sale] = useState<{ library_detail_number: string, id_library_detail?: number | null }[]>([]);
    const [qty_for_sale_api, set_qty_for_sale_api] = useState<{ library_detail_number: string, id_library_detail?: number | null }[]>([]);
    const [qty_for_rent, set_qty_for_rent] = useState<{ library_detail_number: string, id_library_detail?: number | null }[]>([]);
    const [price_amount, set_price_amount] = useState<string>("");
    const [qtyCount, setQtyCount] = useState<string>("");

    function handleChangeFormState<K extends keyof e_library_type>(
        field: K,
        value: e_library_type[K]
    ) {
        setFormState(prev =>
            produce(prev, draft => {
                draft[field] = value
            })
        )
    }
    const handleChangeQty = (
        field: "sale" | "rent",
        value: string,
        index: number
    ) => {
        const updater = field === "sale" ? set_qty_for_sale : set_qty_for_rent;

        updater((prev) =>
            produce(prev, (draft) => {
                if (draft[index]) {
                    draft[index].library_detail_number = value;
                } else {
                    draft.push({ library_detail_number: value });
                }
            })
        );
    };
    const [show_modal, set_show_modal] = useState<NUM_TYPE_MODAL>(NUM_TYPE_MODAL.CLOSE);

    const handleAddPodcastFile = (file: File) => {
        set_podcast_file((prev) => ([...prev, file]))
    }

    const handleCloseModal = () => {
        set_show_modal(NUM_TYPE_MODAL.CLOSE);
        // set_qty_for_sale((prev) => prev.map((x) => ({ ...x, library_detail_number: "" })))
    }
    const handleSubmitQty = (mode: "sale" | "rent") => {
        set_show_modal(NUM_TYPE_MODAL.CLOSE);
        // handleCloseModal();
    }

    // API
    const handleGetDocumentCategory = async (id_library_category: number, id?: number) => {
        await ELibraryApi.documentCategory(id_library_category).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data || [];
                if (id) {
                    handleGetData(+id, response)
                } else {
                    set_document_category_type(response);
                }
                // console.log(response, 'response')
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    const handleGetCategory = async (id?: number) => {
        dispatch(setLoading());
        await ELibraryApi.category().then((res) => {
            if (res.status < 300) {
                const response: category_list[] = res.data?.data || [];
                if (response.length > 0) {
                    const id_response = response?.find((x) => x?.library_category_name === library_category_name);
                    if (id_response?.id_library_category) {
                        handleGetDocumentCategory(id_response?.id_library_category, id);
                    }
                    id_response && set_id_category(id_response);
                }
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            if (!id) {
                dispatch(unsetLoading());
            }
        })
    }
    const handleGetLibraryType = useCallback(async () => {
        const category = media_type_data?.find((x) => x?.key === library_category_name)?.value;
        let query: library_type_list = {
            page: 1,
            limit: 30,
            category_library: category
        }
        if (search_library_type) query.search = search_library_type
        await LibraryTypeApi.list(query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                set_library_type(response);
            }
        }).catch((err) => {
            console.log(err)
        })
    }, [search_library_type])
    const handleGetLibraryAuthor = useCallback(async () => {
        let query: library_author_list = {
            page: 1,
            limit: 30,
        }
        if (search_library_author) query.search = search_library_author
        await LibraryAuthorApi.list(query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                set_library_author(response);
            }
        }).catch((err) => {
            console.log(err)
        })
    }, [search_library_author])
    const handleGetLibraryPublisher = useCallback(async () => {
        let query: library_author_list = {
            page: 1,
            limit: 30,
        }
        if (search_publisher) query.search = search_publisher
        await LibraryAuthorApi.list(query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                set_publisher(response);
            }
        }).catch((err) => {
            console.log(err)
        })
    }, [search_publisher])

    const handleGetData = async (id_library_head: number, document_category?: any[]) => {
        dispatch(setLoading());
        await ELibraryApi.findOne(id_library_head).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data || null;
                const library_head_types: any[] = response?.library_head_types || [];
                const library_details: any[] = response?.library_details || [];
                const library_files: any[] = response?.library_files || [];
                const id_library_author_by = response?.id_library_author_by;
                const id_library_author_publisher = response?.id_library_author_publisher;
                const current_status = response?.status;

                if (current_status) set_status(current_status);
                if (library_files?.length > 0) {
                    const file_cover = library_files?.find((x) => x?.library_file_document === FILE_TYPE_DATA.COVER_FILE);
                    const file_example = library_files?.find((x) => x?.library_file_document === FILE_TYPE_DATA.EXAMPLE_BOOK);
                    const file_video = library_files?.find((x) => x?.library_file_document === FILE_TYPE_DATA.VIDEO_FILE);
                    // console.log(file_video,'file_video')
                    const pod_cast_file = library_files?.filter((x) => (x?.library_file_document === FILE_TYPE_DATA.POD_CAST || x?.library_file_document === FILE_TYPE_DATA.AUDIO_BOOK)).map((list) => {
                        return {
                            checked_example: !!list?.is_example,
                            link_file: list?.link_file,
                            file: list
                        }
                    });
                    const file_complete = library_files?.find((x) =>
                        x?.library_file_document === FILE_TYPE_DATA.COMPLETE_BOOK ||
                        x?.library_file_document === FILE_TYPE_DATA.COMPLETE_THE_SIS_FILE ||
                        x?.library_file_document === FILE_TYPE_DATA.JOURNAL_FILE
                    );
                    const find_document_category_type =
                        document_category?.find(
                            (x) => (x.library_file_document === FILE_TYPE_DATA.POD_CAST || x.library_file_document === FILE_TYPE_DATA.AUDIO_BOOK)
                        );
                    const map_pod_cast_documentary_data = Array.from({ length: pod_cast_file?.length })?.map(() => {
                        return find_document_category_type
                    });
                    if (document_category && pod_cast_file?.length > 0) {
                        set_document_category_type([...document_category?.filter((x) => x?.library_file_document !== FILE_TYPE_DATA.POD_CAST), ...map_pod_cast_documentary_data]);
                    } else if (document_category) {
                        set_document_category_type(document_category);
                    }
                    set_podcast_file([find_document_category_type, ...pod_cast_file]);
                    set_cover_file(file_cover || null);
                    set_example_book(file_example || null);
                    if (file_video?.link_file) {
                        set_video_link(file_video?.link_file);
                    }
                    set_video_file(file_video || null);
                    set_complete_book(file_complete);
                } else {
                    document_category && set_document_category_type(document_category);
                }
                if (id_library_author_by) {
                    const obj_data = {
                        id_library_author: id_library_author_by,
                        library_author_name: response?.library_author_by || ""
                    }
                    set_id_library_author(obj_data)
                }
                if (id_library_author_publisher) {
                    const obj_data = {
                        id_library_author: id_library_author_by,
                        library_author_name: response?.library_author_publisher || ""
                    }
                    set_id_publisher(obj_data)
                }
                const rent_qty: any[] = library_details?.filter((x) => x?.library_detail_type === LIBRARY_DETAIL_TYPE.RENT);
                const sales_qty: any[] = library_details?.filter((x) => x?.library_detail_type === LIBRARY_DETAIL_TYPE.SALES);
                set_qty_for_sale_api(sales_qty)
                if (sales_qty?.length > 0) {
                    const price_amount_response = sales_qty?.find((x) => x)?.price_amount || "";
                    set_price_amount(String(price_amount_response || ""))
                }
                // console.log(sales_qty, 'sales_qty')
                set_qty_for_sale(sales_qty);
                set_qty_for_rent(rent_qty);
                if (library_head_types?.length > 0) {
                    set_id_library_type(library_head_types)
                }
                setFormState((prev) => ({ ...prev, ...response }))
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    const clearFile = () => {
        set_cover_file(null);
        set_example_book(null);
        set_complete_book(null);
    }
    const generateFile = async (file: File[]): Promise<file_response_e_library[]> => {
        if (file?.length > 0) {
            const form_data = new FormData();
            file.forEach((list) => {
                form_data.append('files', list)
            })
            const file_data = await ELibraryApi.createFile(library_category_name, form_data).then((res) => {
                if (res.status < 300) {
                    const response = res.data?.data || [];
                    return response
                }
            }).catch((err) => {
                console.log(err);
                return []
            })
            return file_data
        } else {
            return []
        }
    }

    const findDoc = (docType: FILE_TYPE_DATA) => {
        const doc = document_category_type?.find((x) => x?.library_file_document === docType);
        return {
            library_file_document: doc?.library_file_document || "",
            id_library_file_document: doc?.id_library_file_document ?? null,
            seq: doc?.seq ?? null,
        };
    };
    const isObject = (v: any): v is Record<string, any> =>
        v !== null && typeof v === 'object';

    const hasProp = (v: any, k: string): boolean =>
        isObject(v) && k in v;

    const isNonEmptyString = (s: any): s is string =>
        typeof s === 'string' && s.trim().length > 0;

    const isBrowserFile = (f: any): f is File =>
        typeof File !== 'undefined' && f instanceof File;

    const podcastItemType = (raw: any) => {
        const x = raw ?? {};
        if (isObject(x) && isNonEmptyString(x.link_file)) {
            return 'LINK' as const;
        }
        if (isObject(x) && x.file && isBrowserFile(x.file)) {
            return 'NEW_FILE' as const;
        }
        if (
            isObject(x) &&
            (
                (isObject(x.file) && hasProp(x.file, 'id_library_file')) ||
                hasProp(x, 'id_library_file')
            )
        ) {
            return 'EXISTING_FILE' as const;
        }
        return 'EMPTY' as const;
    };

    const generateForm = async (mode: mode_status): Promise<e_library_type> => {
        const file_data_cover_file: File[] = [];
        const file_data_example_book: File[] = [];
        const file_data_complete_book: File[] = [];
        const file_data_video_file: File[] = [];

        if (cover_file && cover_file instanceof File) file_data_cover_file.push(cover_file);
        if (example_book && example_book instanceof File) file_data_example_book.push(example_book);
        if (complete_book && complete_book instanceof File) file_data_complete_book.push(complete_book);
        if (video_file && video_file instanceof File) file_data_video_file.push(video_file);

        const id_library_file_cover_api = (cover_file as any)?.id_library_file;
        const id_library_file_example_api = (example_book as any)?.id_library_file;
        const id_library_file_complete_api = (complete_book as any)?.id_library_file;
        const id_library_file_video_api = (video_file as any)?.id_library_file;

        const coverMeta = findDoc(FILE_TYPE_DATA.COVER_FILE);
        const response_cover_file: file_response_e_library[] =
            file_data_cover_file.length > 0
                ? (await generateFile(file_data_cover_file)).map((list) => ({
                    ...list,
                    ...coverMeta,
                    is_example: false,
                    library_file_type: LIBRARY_FILE_TYPE.FILE,
                    link_file: "",
                }))
                : id_library_file_cover_api
                    ? [{
                        id_library_file: id_library_file_cover_api,
                        is_example: false,
                        library_file_type: LIBRARY_FILE_TYPE.FILE,
                        link_file: video_link || "",
                        ...coverMeta,
                    } as file_response_e_library]
                    : [];

        const videoFileMeta = findDoc(FILE_TYPE_DATA.VIDEO_FILE);
        const response_video_file: file_response_e_library[] =
            file_data_video_file.length > 0
                ? (await generateFile(file_data_video_file)).map((list) => ({
                    ...list,
                    ...videoFileMeta,
                    is_example: false,
                    library_file_type: LIBRARY_FILE_TYPE.FILE,
                    link_file: "",
                }))
                : id_library_file_video_api
                    ? [{
                        id_library_file: id_library_file_video_api,
                        is_example: false,
                        library_file_type: LIBRARY_FILE_TYPE.FILE,
                        link_file: "",
                        ...videoFileMeta,
                    } as file_response_e_library]
                    : [];

        // ---------- EXAMPLE_BOOK ----------
        const exampleMeta = findDoc(FILE_TYPE_DATA.EXAMPLE_BOOK);
        const response_example_book: file_response_e_library[] =
            file_data_example_book.length > 0
                ? (await generateFile(file_data_example_book)).map((list) => ({
                    ...list,
                    ...exampleMeta,
                    is_example: true,
                    library_file_type: LIBRARY_FILE_TYPE.FILE,
                    link_file: "",
                }))
                : id_library_file_example_api
                    ? [{
                        id_library_file: id_library_file_example_api,
                        is_example: true,
                        library_file_type: LIBRARY_FILE_TYPE.FILE,
                        link_file: "",
                        ...exampleMeta,
                    } as file_response_e_library]
                    : [];

        const completeDoc =
            document_category_type?.find(
                (x) =>
                    x?.library_file_document === FILE_TYPE_DATA.COMPLETE_BOOK ||
                    x?.library_file_document === FILE_TYPE_DATA.COMPLETE_THE_SIS_FILE ||
                    x?.library_file_document === FILE_TYPE_DATA.JOURNAL_FILE
            ) || null;

        const completeMeta = {
            library_file_document: completeDoc?.library_file_document || "",
            id_library_file_document: completeDoc?.id_library_file_document ?? null,
            seq: completeDoc?.seq ?? null,
        };

        const response_complete_book: file_response_e_library[] =
            file_data_complete_book.length > 0
                ? (await generateFile(file_data_complete_book)).map((list) => ({
                    ...list,
                    ...completeMeta,
                    is_example: false,
                    library_file_type: LIBRARY_FILE_TYPE.FILE,
                    link_file: "",
                }))
                : id_library_file_complete_api
                    ? [{
                        id_library_file: id_library_file_complete_api,
                        is_example: false,
                        library_file_type: LIBRARY_FILE_TYPE.FILE,
                        link_file: "",
                        ...completeMeta,
                    } as file_response_e_library]
                    : [];

        const is_video = (ELibraryCategory.VIDEO === library_category_name)
        const is_audio_book = (ELibraryCategory.AUDIO_BOOK === library_category_name)
        const podcastMeta = findDoc(FILE_TYPE_DATA.POD_CAST);
        const audioBookMeta = findDoc(FILE_TYPE_DATA.AUDIO_BOOK);
        const videoMeta = findDoc(FILE_TYPE_DATA.VIDEO_FILE);

        type PodcastItem = {
            file?: any;
            link_file?: string | null;
            checked_example?: boolean;
            id_library_file?: number | null;
            id_library_document_category?: number | null;
        };

        const podcastList: PodcastItem[] = (podcast_file as PodcastItem[] | undefined) ?? [];

        const newFiles: File[] = [];
        const newFileIndexMap: number[] = [];
        podcastList.forEach((x, idx) => {
            if (podcastItemType(x) === 'NEW_FILE') {
                newFiles.push(x.file as File);
                newFileIndexMap.push(idx);
            }
        });

        const uploadedNewFiles = newFiles.length ? await generateFile(newFiles) : [];

        const podcastOrdered: file_response_e_library[] = [];
        let upPtr = 0;
        podcastList.forEach((x, idx) => {
            const kind = podcastItemType(x);
            if (kind === 'NEW_FILE') {
                const uploaded = uploadedNewFiles[upPtr++];
                if (!uploaded) return;
                podcastOrdered.push({
                    ...uploaded,
                    ...(is_video ? videoMeta : is_audio_book ? audioBookMeta : podcastMeta),
                    library_file_type: is_video ? LIBRARY_FILE_TYPE.VIDEO : LIBRARY_FILE_TYPE.VOICE,
                    link_file: "",
                    is_example: !!x.checked_example,
                });
                return;
            }
            if (kind === 'EXISTING_FILE') {
                const id_library_file = (x.file && x.file.id_library_file) || x.id_library_file || null;
                if (!id_library_file) return;
                podcastOrdered.push({
                    id_library_file,
                    ...(is_video ? videoMeta : is_audio_book ? audioBookMeta : podcastMeta),
                    library_file_type: is_video ? LIBRARY_FILE_TYPE.VIDEO : LIBRARY_FILE_TYPE.VOICE,
                    link_file: "",
                    is_example: !!(x.checked_example ?? x.file?.is_example),
                } as file_response_e_library);
                return;
            }
            if (kind === 'LINK') {
                podcastOrdered.push({
                    id_library_file: null,
                    id_library_document_category: x?.id_library_document_category ?? null,
                    ...(is_video ? videoMeta : is_audio_book ? audioBookMeta : podcastMeta),
                    library_file_type: LIBRARY_FILE_TYPE.LINK,
                    link_file: x.link_file || x?.file?.link_file || "",
                    is_example: !!x.checked_example,
                } as file_response_e_library);
                return;
            }
        });


        let merged_data: file_response_e_library[] = [
            ...response_cover_file,
            ...response_example_book,
            ...response_complete_book,
            ...response_video_file,
            ...podcastOrdered,
        ].map((list, i) => ({ ...list, seq: i + 1 }));

        const library_details_sales: library_details[] = qty_for_sale?.map((list) => ({
            id_library_detail: list?.id_library_detail || null,
            library_detail_number: list?.library_detail_number,
            library_detail_type: LIBRARY_DETAIL_TYPE.SALES,
            price_amount: price_amount ? +price_amount : 0,
        })) || [];

        const library_details_rent: library_details[] = qty_for_rent?.map((list) => ({
            id_library_detail: list?.id_library_detail || null,
            library_detail_number: list?.library_detail_number,
            library_detail_type: LIBRARY_DETAIL_TYPE.RENT,
        })) || [];

        const all_library_details = [...library_details_sales, ...library_details_rent];

        return {
            // ...formState,
            language: formState.language,
            library_category_desc: formState.library_category_desc,
            library_episodes: formState.library_episodes,
            library_head_name: formState.library_head_name,
            library_head_status: formState.library_head_status,
            library_page: formState.library_page,
            is_draft: mode === 'DRAFT',
            id_library_author_publisher: id_publisher?.id_library_author || null,
            library_author_publisher: id_publisher?.library_author_name || "",
            id_library_author_by: id_library_author?.id_library_author || null,
            library_author_by: id_library_author?.library_author_name || "",
            library_payment_day: Number(formState.library_payment_day || 0),
            library_payment_hour: Number(formState.library_payment_hour || 0),
            library_rent_day: Number(formState.library_rent_day || 0),
            library_rent_hour: Number(formState.library_rent_hour || 0),
            library_details: all_library_details,
            id_library_category: id_category.id_library_category,
            library_category_name: id_category.library_category_name,
            library_head_types: (id_library_type?.length ? id_library_type : [])?.map((list) => ({
                library_type_name: list?.library_type_name,
                id_library_type: list?.id_library_type,
                id_library_head_type: list?.id_library_head_type || null,
            })),
            library_files: merged_data?.length
                ? merged_data.map((list) => ({
                    id_library_file: list?.id_library_file,
                    id_library_file_document: list?.id_library_file_document,
                    is_example: list?.is_example,
                    library_file_document: list?.library_file_document,
                    library_file_type: list?.library_file_type,
                    link_file: list?.link_file,
                    seq: list?.seq,
                }))
                : [],
        };
    };

    const handleSubmitForm = async (mode: mode_status) => {
        const body = await generateForm(mode);
        dispatch(setLoading());
        if (id) {
            await ELibraryApi.update(+id, body).then((res) => {
                if (res.status < 300) {
                    handleGetData(+id);
                    alertSuccess("อัพเดตข้อมูล", "อัพเดตข้อมูล เรียบร้อย");
                }
            }).catch((err) => {
                console.log(err);
                alertError("อัพเดตข้อมูล ไม่สำเร็จ", err?.response?.data?.message || "");
                handleGetData(+id)
            }).finally(() => {
                dispatch(unsetLoading());
                clearFile();
            })
        } else {
            await ELibraryApi.create(body).then((res) => {
                if (res.status < 300) {
                    const response = res.data?.data || [];
                    const id_library_head = response?.id_library_head;
                    const alert_message: { key: string, title: string, detail: string }[] = [
                        {
                            key: ELibraryCategory.BOOK,
                            detail: "เพิ่มหนังสือ",
                            title: "เพิ่มหนังสือ เรียบร้อย"
                        },
                        {
                            key: ELibraryCategory.E_BOOK,
                            detail: "เพิ่มE-Book",
                            title: "เพิ่มE-Book เรียบร้อย"
                        },
                        {
                            key: ELibraryCategory.THESIS,
                            detail: "เพิ่มวิทยานิพนธ์",
                            title: "เพิ่มวิทยานิพนธ์ เรียบร้อย"
                        },
                        {
                            key: ELibraryCategory.MAGAZINE,
                            detail: "เพิ่มวารสาร",
                            title: "เพิ่มวารสาร เรียบร้อย"
                        },
                        {
                            key: ELibraryCategory.VIDEO,
                            detail: "เพิ่มวีดีโอ",
                            title: "เพิ่มวีดีโอ เรียบร้อย"
                        },
                        {
                            key: ELibraryCategory.AUDIO_BOOK,
                            detail: "เพิ่มหนังสือเสียง",
                            title: "เพิ่มหนังสือเสียง เรียบร้อย"
                        },
                        {
                            key: ELibraryCategory.PODCAST,
                            detail: "เพิ่มพอดแคสต์",
                            title: "เพิ่มพอดแคสต์ เรียบร้อย"
                        },
                    ]
                    const find_one_message = alert_message?.find((x) => x?.key === library_category_name);
                    alertSuccess(find_one_message?.title || "", find_one_message?.detail || "", undefined, () => {
                        if (id_library_head) {
                            if (ELibraryCategory.BOOK === library_category_name) {
                                window.location.replace(routeName.e_library.manage_books_detail.replace(":id", id_library_head))
                            } else if (ELibraryCategory.E_BOOK === library_category_name) {
                                window.location.replace(routeName.e_library.manage_e_books_detail.replace(":id", id_library_head))
                            } else if (ELibraryCategory.THESIS === library_category_name) {
                                window.location.replace(routeName.e_library.manage_the_ses_detail.replace(":id", id_library_head))
                            } else if (ELibraryCategory.MAGAZINE === library_category_name) {
                                window.location.replace(routeName.e_library.manage_journal_detail.replace(":id", id_library_head))
                            } else if (ELibraryCategory.PODCAST === library_category_name) {
                                window.location.replace(routeName.e_library.manage_podcast_detail.replace(":id", id_library_head))
                            } else if (ELibraryCategory.VIDEO === library_category_name) {
                                window.location.replace(routeName.e_library.manage_videos_detail.replace(":id", id_library_head))
                            } else if (ELibraryCategory.AUDIO_BOOK === library_category_name) {
                                window.location.replace(routeName.e_library.manage_audio_book_detail.replace(":id", id_library_head))
                            }
                        }
                    });
                    if (id_library_head) {
                        if (ELibraryCategory.BOOK === library_category_name) {
                            window.location.replace(routeName.e_library.manage_books_detail.replace(":id", id_library_head))
                        } else if (ELibraryCategory.E_BOOK === library_category_name) {
                            window.location.replace(routeName.e_library.manage_e_books_detail.replace(":id", id_library_head))
                        } else if (ELibraryCategory.THESIS === library_category_name) {
                            window.location.replace(routeName.e_library.manage_the_ses_detail.replace(":id", id_library_head))
                        } else if (ELibraryCategory.MAGAZINE === library_category_name) {
                            window.location.replace(routeName.e_library.manage_journal_detail.replace(":id", id_library_head))
                        } else if (ELibraryCategory.PODCAST === library_category_name) {
                            window.location.replace(routeName.e_library.manage_podcast_detail.replace(":id", id_library_head))
                        } else if (ELibraryCategory.VIDEO === library_category_name) {
                            window.location.replace(routeName.e_library.manage_videos_detail.replace(":id", id_library_head))
                        } else if (ELibraryCategory.AUDIO_BOOK === library_category_name) {
                            window.location.replace(routeName.e_library.manage_audio_book_detail.replace(":id", id_library_head))
                        }
                    } else {
                        if (ELibraryCategory.BOOK === library_category_name) {
                            navigate(routeName.e_library.manage_books);
                        } else if (ELibraryCategory.E_BOOK === library_category_name) {
                            navigate(routeName.e_library.manage_e_books);
                        } else if (ELibraryCategory.THESIS === library_category_name) {
                            navigate(routeName.e_library.manage_the_ses);
                        } else if (ELibraryCategory.MAGAZINE === library_category_name) {
                            navigate(routeName.e_library.manage_journal);
                        } else if (ELibraryCategory.PODCAST === library_category_name) {
                            navigate(routeName.e_library.manage_podcast);
                        } else if (ELibraryCategory.VIDEO === library_category_name) {
                            navigate(routeName.e_library.manage_videos);
                        } else if (ELibraryCategory.AUDIO_BOOK === library_category_name) {
                            navigate(routeName.e_library.audio_book);
                        }
                    }
                }
            }).catch((err) => {
                console.log(err);
                alertError("อัพเดตข้อมูล ไม่สำเร็จ", err?.response?.data?.message || "");
                if (id) {
                    handleGetData(+id)
                }
            }).finally(() => {
                dispatch(unsetLoading());
                clearFile();
            })
        }
    }
    const makeEmptyItems = (n: number) =>
        Array.from({ length: n }, () => ({ library_detail_number: "" }));

    useEffect(() => {
        const target = qty_for_sale?.length ? String(qty_for_sale.length) : "";
        setQtyCount(target);
    }, [qty_for_sale?.length]);

    useEffect(() => {
        handleGetCategory(id ? +id : undefined);
    }, [id])
    useEffect(() => {
        handleGetLibraryPublisher();
    }, [handleGetLibraryPublisher])
    useEffect(() => {
        handleGetLibraryAuthor();
    }, [handleGetLibraryAuthor])
    useEffect(() => {
        handleGetLibraryType();
    }, [handleGetLibraryType])

    return {
        pathname,
        cover_file,
        set_cover_file,
        example_book,
        set_example_book,
        handleCloseModal,
        show_modal,
        NUM_TYPE_MODAL,
        set_show_modal,
        set_qty_for_sale,
        set_qty_for_rent,
        qty_for_sale,
        qty_for_rent,
        handleChangeQty,
        handleSubmitQty,
        formState,
        library_type,
        set_search_library_type,
        id_library_type,
        set_id_library_type,
        id_library_author,
        set_id_library_author,
        set_search_library_author,
        library_author,
        publisher,
        set_id_publisher,
        set_search_publisher,
        id_publisher,
        handleSubmitForm,
        handleChangeFormState,
        price_amount,
        set_price_amount,
        document_category_type,
        complete_book,
        set_complete_book,
        handleAddPodcastFile,
        podcast_file,
        set_podcast_file,
        set_document_category_type,
        status,
        makeEmptyItems,
        setQtyCount,
        qtyCount,
        qty_for_sale_api,
        video_file,
        set_video_file,
        video_link,
        set_video_link

    }
}